import { Button, Skeleton } from '@chakra-ui/react';
import { ExternalRegionLink, useExperiment } from '@acp/feature/auth';
import React from 'react';
import { Experiment } from '@acp/shared';
import { PropertyRequestModalOpenEvents } from './lazy-loaded/types';
import { PropertyRequestCreatorContext } from '../create-request/creator-machine/context';

type NewWorkOrderButtonProps = {
    legacyPath?: string;
    eventGenerator?: () => PropertyRequestModalOpenEvents;
} & React.ComponentProps<typeof Button>;

function ButtonSkeleton({ children, ...props }: NewWorkOrderButtonProps) {
    return (
        <Skeleton>
            <Button
                {...props}
            >
                { children }
            </Button>
        </Skeleton>
    );
}

function NewWorkOrderButton({ children, legacyPath, ...props }: NewWorkOrderButtonProps) {
    const { hasExperiment, isLoading } = useExperiment();
    const machine = PropertyRequestCreatorContext.useActorRef();

    if (isLoading) {
        return <ButtonSkeleton {...props}>{children}</ButtonSkeleton>;
    }

    if (!hasExperiment(Experiment.PropertyRequestEnrolmentV1)) {
        return (
            <Button
                as={ExternalRegionLink}
                path={legacyPath ?? '/JobOrders/add'}
                target="_blank"
                textDecoration="none"
                {...props}
            >
                {children}
            </Button>
        );
    }

    return (
        <Button
            {...props}
            onClick={(e) => {
                props.onClick?.(e);

                if (props.eventGenerator !== undefined) {
                    machine.send(props.eventGenerator());
                    return;
                }

                machine.send({
                    type: 'OPEN',
                });
            }}
        >
            {children}
        </Button>
    );
}

export { NewWorkOrderButton };
